import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { InfiniteScrollStore } from '../../../../../shared/store/common/infinite-scroll.store';
import { usersFrag } from './form-base-form.query';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { getEmploymentEnumsByParentGroup } from '@libs/types/src/user/enum/employment.enum';
import { EmploymentParentGroupEnum } from '@libs/types/src/user/enum/employment-parent-group.enum';

@Injectable()
export class FormBaseFormStore extends ComponentStoreV2Factory {

    public userScroll = computed(() => {
        const filter = new FilterBuilder();
        filter.serviceId(this.globalGlobalStore.loggedUserStore.selectedServiceId());
        filter.where('employment', getEmploymentEnumsByParentGroup(EmploymentParentGroupEnum.DIRECT_CARE));
        filter.limit(100);

        return new InfiniteScrollStore(
            this.api.getUsers,
            filter.filter(),
            true,
            usersFrag,
            undefined,
            true,
        );
    });

}
